module.exports = __webpack_public_path__ + "static/media/rate_video_bg_full.c036c22f.png";